import React from "react"
import { Helmet } from "react-helmet"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import { Box, Typography } from "@material-ui/core"

export default function Template({ data }) {
  const { markdownRemark: post } = data
  return (
    <Layout>
      <Box display="flex" flexDirection="column">
        <Helmet title={`Your Blog Name - ${post.frontmatter.title}`} />
        <Box display="flex" flexDirection="row">
          <Box>
            <Typography variant="h3">{post.frontmatter.title}</Typography>
          </Box>
        </Box>
        <Box dangerouslySetInnerHTML={{ __html: post.html }} m={1}/>
      </Box>
    </Layout>
  )
}

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
      }
    }
  }
`
